import { useGetApiV1IndividualpaymentSharedPaymentTypes } from '@/shared/api/generated';
import { type LookupOption, mapDropdownOptions } from '@/shared/ui/molecules/LookupAutocomplete';

/**
 * Métodos de pagamento disponíveis para o filtro — lista fechada, carregada uma
 * única vez (sem termo de busca). Equivale ao enum `EPaymentMethod` (1..7),
 * mas com os rótulos já localizados pelo backend.
 *
 * @param enabled - `false` impede a consulta. Existe para telas que só precisam do
 *   dicionário quando há um contrato válido: sem isso, um parâmetro de rota
 *   corrompido ainda disparava esta request antes da tela mostrar o erro.
 * @returns `{ paymentTypes, isLoading }`.
 *
 * @example
 * ```tsx
 * const { paymentTypes } = usePaymentTypesDropdown();
 * ```
 */
export function usePaymentTypesDropdown(enabled = true): {
  readonly paymentTypes: readonly LookupOption[];
  readonly isLoading: boolean;
} {
  const { data, isLoading } = useGetApiV1IndividualpaymentSharedPaymentTypes(undefined, {
    query: { enabled },
  });

  return { paymentTypes: mapDropdownOptions(data), isLoading: enabled && isLoading } as const;
}
